import React, { useEffect, useState } from "react";
import { Box, ListItem, Typography } from "@mui/material";
import { Link, NavLink, redirect } from "react-router-dom";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../store/hooks/store.hooks";
import PersonIcon from "@mui/icons-material/Person";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import LockIcon from "@mui/icons-material/Lock";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { useTranslation } from "react-i18next";

import { logout } from "../../../store/models/auth/auth.thunk";
import { ProfileMenuSelector } from "./ProfileMenu.selector";
import "./ProfileMenu.css";
import { googleLogout } from "@react-oauth/google";
import {
  setAuthorizationModal,
  setRegistrationModal,
} from "../../../store/models/auth/auth.slice";
import { Loader } from "../../loader/loader";
import bonuses from "../../../assets/icons/menu/bonuses.svg";
import exit from "../../../assets/icons/menu/exit.svg";
import security from "../../../assets/icons/menu/security.svg";
import personal_account from "../../../assets/icons/menu/personal_account.svg";
import copy from "../../../assets/icons/copy.svg";
import avatar from "../../../assets/icons/avatar.svg";
import arrow from "../../../assets/icons/arrow-down.svg";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

interface IProfileMenuProps {
  items: {
    to: string;
    text: string;
  }[];
}

export const ProfileMenu = ({ items }: IProfileMenuProps) => {
  const { t } = useTranslation();
  // const [globalLoading, setGlobalLoading] = useState(true);
  const dispatch = useAppDispatch();
  const [copied, setCopied] = useState(false);
  const { summaryBalance, userBalance, currency, name, surname, id, coins } =
    useAppSelector(ProfileMenuSelector);
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 3000);
    }
  }, [copied]);

  return (
    <Box className={opened ? "profile-menu active" : "profile-menu"}>
      <Box
        className="profile-menu__opener"
        onClick={() => {
          setOpened(!opened);
        }}
      >
        <img src={arrow} alt="Open" />
      </Box>
      <Box className="profile-menu__personal">
        <Box className="profile-menu__personal-image">
          <img src={avatar} alt="Avatar" />
        </Box>
        <Box className="profile-menu__name">
          <Typography variant="body1">{name || ""}</Typography>
          <Typography variant="body1">{surname || ""}</Typography>
        </Box>
        <Typography
          variant="body1"
          className="profile-menu__id"
          onClick={() => {
            navigator.clipboard
              .writeText(id)
              .then(() => {
                setCopied(true);
              })
              .catch((err) => {
                console.error("Error");
              });
          }}
        >
          {`ID: ${id || ""}`}
          {copied ? (
            <CheckCircleIcon
              id="copied"
              color="success"
              sx={{ height: "18px", width: "19px" }}
            />
          ) : (
            <CopyIcon />
          )}
        </Typography>
      </Box>

      <Box className="profile-menu__menu">
        <ul className="profile-menu__list">
          {items.map((menu_item) => {
            return (
              <ListItem className="profile-menu__item" key={menu_item.to}>
                <NavLink
                  to={menu_item.to}
                  className="profile-menu__item-link"
                  end
                >
                  {menu_item.text}
                </NavLink>
              </ListItem>
            );
          })}
        </ul>
      </Box>
      <Box className="profile-menu__footer">
        <button
          onClick={async () => {
            await dispatch(logout());
            await googleLogout();
            window.location.href = "/";
          }}
          className="profile-menu__footer-button"
        >
          <img src={exit} alt="log out" />
          {t("buttons.quit")}
        </button>
      </Box>
    </Box>
  );
};

export const CopyIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.75 6.75V4.65015C11.75 3.81007 11.75 3.38972 11.5865 3.06885C11.4427 2.7866 11.2134 2.5573 10.9312 2.41349C10.6103 2.25 10.1899 2.25 9.34985 2.25H5.14985C4.30977 2.25 3.88995 2.25 3.56909 2.41349C3.28684 2.5573 3.05714 2.7866 2.91333 3.06885C2.74984 3.38972 2.74984 3.80975 2.74984 4.64983V8.84985C2.74984 9.68993 2.74984 10.11 2.91333 10.4308C3.05714 10.7131 3.28707 10.9429 3.56931 11.0867C3.88986 11.25 4.30925 11.25 5.14768 11.25H7.25M11.75 6.75H13.8499C14.6899 6.75 15.1103 6.75 15.4312 6.91349C15.7134 7.0573 15.9427 7.2866 16.0865 7.56885C16.25 7.88972 16.25 8.31007 16.25 9.15015V13.3501C16.25 14.1902 16.25 14.61 16.0865 14.9309C15.9427 15.2132 15.7134 15.4429 15.4312 15.5867C15.1106 15.75 14.6908 15.75 13.8523 15.75H9.64734C8.8089 15.75 8.38964 15.75 8.06909 15.5867C7.78685 15.4429 7.55714 15.2129 7.41333 14.9307C7.25 14.6101 7.25 14.1908 7.25 13.3523V11.25M11.75 6.75H9.64985C8.80977 6.75 8.38996 6.75 8.06909 6.91349C7.78685 7.0573 7.55714 7.2866 7.41333 7.56885C7.25 7.8894 7.25 8.30925 7.25 9.14771L7.25 11.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
